import * as textConstants from '../text/constants';

export const { SIZES, APPEARANCES, TYPES, WEIGHTS } = textConstants;
